"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.ScreenP2PConfirmRentAmountAnalyticsEvent = exports.ScreenP2PConfirmAddressAnalyticsEvent = exports.P2PUpdateRentCtaClickedAnalyticsEvent = exports.P2PUpdatePropertyCtaClickedAnalyticsEvent = exports.P2PUpdateAddressCtaClickedAnalyticsEvent = exports.P2PConfirmRentAmountCtaClickedAnalyticsEvent = exports.P2PConfirmAddressCtaClickedAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when user clicks the 'Update property' button on the 'Action required to continue using Flex' screen in the Onboarding Flow
 */
var P2PUpdatePropertyCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('P2P_update_property_cta_clicked');
exports.P2PUpdatePropertyCtaClickedAnalyticsEvent = P2PUpdatePropertyCtaClickedAnalyticsEvent;
/**
 * Triggers when user clicks the 'See more details' button on the 'Action required to continue using Flex' screen in the Onboarding Flow
 */
var P2PUpdateRentCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('P2P_update_rent_cta_clicked');
exports.P2PUpdateRentCtaClickedAnalyticsEvent = P2PUpdateRentCtaClickedAnalyticsEvent;
/**
 * Triggers when user clicks the 'See more details' button on the 'Action required to continue using Flex' screen in the Onboarding Flow
 */
var P2PUpdateAddressCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('P2P_update_address_cta_clicked');
exports.P2PUpdateAddressCtaClickedAnalyticsEvent = P2PUpdateAddressCtaClickedAnalyticsEvent;
/**
 * Triggers when user views the 'Search for your property' screen in the Onboarding Flow
 */
var ScreenP2PConfirmAddressAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_P2P_confirm_address');
exports.ScreenP2PConfirmAddressAnalyticsEvent = ScreenP2PConfirmAddressAnalyticsEvent;
/**
 * Triggers when user clicks the 'Confirm' button on the 'Confirm your address' screen in the Onboarding Flow
 */
var P2PConfirmAddressCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('P2P_confirm_address_cta_clicked');
exports.P2PConfirmAddressCtaClickedAnalyticsEvent = P2PConfirmAddressCtaClickedAnalyticsEvent;
/**
 * Triggers when user views the 'Confirm your rent amount' screen in the Onboarding Flow
 */
var ScreenP2PConfirmRentAmountAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('screen_P2P_confirm_rent_amount');
exports.ScreenP2PConfirmRentAmountAnalyticsEvent = ScreenP2PConfirmRentAmountAnalyticsEvent;
/**
 * Triggers when user clicks the 'Confirm' button on the 'Confirm your rent amount' screen in the Onboarding Flow
 */
var P2PConfirmRentAmountCtaClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('P2P_confirm_rent_amount_cta_clicked');
exports.P2PConfirmRentAmountCtaClickedAnalyticsEvent = P2PConfirmRentAmountCtaClickedAnalyticsEvent;
